var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 26906"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 3654"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.80375 3.57713V8.42234L6.00004 10.8452L10.1963 8.42234V3.57713L6.00004 1.15428L1.80375 3.57713ZM11.1963 8.71141L11.1919 8.77732C11.1716 8.92989 11.0817 9.06632 10.9463 9.14451L6.25004 11.8554C6.11466 11.9336 5.95186 11.9434 5.80961 11.8847L5.75004 11.8554L1.05375 9.14451C0.918329 9.06632 0.82844 8.92989 0.808143 8.77732L0.803748 8.71141V3.28855C0.803784 3.10997 0.899088 2.94475 1.05375 2.85545L5.75004 0.144511C5.90474 0.0551949 6.09534 0.0551949 6.25004 0.144511L10.9463 2.85545C11.101 2.94475 11.1963 3.10997 11.1963 3.28855V8.71141Z",
    fill: "#634EE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41606 5.44313L5.92177 6.31243L1.30531 3.68751L1.79959 2.81821L6.41606 5.44313Z",
    fill: "#634EE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58403 5.44313L6.07831 6.31243L10.6948 3.68751L10.2005 2.81821L5.58403 5.44313Z",
    fill: "#634EE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.50004 11.5625H5.50004L5.50004 5.40626H6.50004L6.50004 11.5625Z",
    fill: "#634EE6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/course.e94101fe52f60f767df7269322ec1a0e.svg";
export { ForwardRef as ReactComponent };